import { NumberRangeBaseMiddlewareUtils } from '../shared/numberRangeBaseMiddlewareUtils';

import type { IFilterMiddlewareUtils } from '../shared/types';
import type { IRevenueRangeFilterValue } from './types';

/**
 * 收入范围筛选器中间件工具
 * 复用 NumberRangeBaseMiddlewareUtils 基类逻辑
 */
class RevenueRangeMiddlewareUtils
  extends NumberRangeBaseMiddlewareUtils
  implements IFilterMiddlewareUtils<IRevenueRangeFilterValue, IRecord<number>> {}

export default RevenueRangeMiddlewareUtils;
